require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./public-support-for-prison-reduction.json") })
        }
      }, "path---public-support-for-prison-reduction");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---public-support-for-prison-reduction!./.cache/json/public-support-for-prison-reduction.json
// module id = 963
// module chunks = 231608221292675